import React, { memo, useEffect, useState } from 'react'
import { Draggable } from '@fullcalendar/interaction';

const SideOptionsPanel = (props) => {

  //const [calendarTime, setCalendarTime] = useState('');

  useEffect(() => {
    //console.log(props, props.options)
    
    const items = document.getElementsByClassName('drag');

    for(var i=0;i<=items.length;i++){
     

      if(!props.options[i] || items[i] === null || items[i] === undefined){
        continue;
      }

      
      var calendarTime = props.options[i].duration < 10 ? '0'+ props.options[i].duration + ':00' : props.options[i].duration + ':00';
      
      if(props.options[i].duration % 1 < 1 && props.options[i].duration % 1 > 0){

        const calcTime = 60 * (props.options[i].duration % 1)

        //console.log(props.options[i].duration, props.options[i].duration % 1, calcTime);

        calendarTime = (props.options[i].duration >= 1 && props.options[i].duration < 10 ? 
          '0'+ (props.options[i].duration - props.options[i].duration % 1) + ':' + calcTime :
          props.options[i].duration < 1 ? '00:' + calcTime :  props.options[i].duration + ':' + calcTime)
      }
      
      //console.log(calendarTime);

      new Draggable(items[i], {
        itemSelector: '.drag',
        eventData: {
            id: props.options[i].id,
            title: props.options[i].display_name,
            duration: calendarTime,
            service: props.options[i]
          }});
    }

  })
  

  return (
    <div className='p-4 side-option-panel rounded mb-3'>
        <h2>{props.heading}</h2>
        <small><i>{props.description}</i></small>

        <ul className='list-group'>
            {props.options && props.options.map((option, index) => (
                <li key={index} 
                    title={option.display_name} 
                    id={option.id} 
                    data-event={'{ "title": "' + option.display_name + '", "duration": "' + option.duration + '" }'}
                    className='drag list-group-item'>
                  <b>{option.display_name}</b> | &nbsp;
                  <small>{option.duration} {option.duration > 1 ? 'hrs' : 'hr'}</small>
                </li>
            ))}
        </ul>

    </div>
  )
}

export default memo(SideOptionsPanel);